import { config } from '@uhg-abyss/web/tools/config';
import { http } from '../../tools/http';
import { getTechnicalUserData } from '../user/helpers';
import {
  parseProvider,
  parseOrganizations,
  parseProviders,
  parseEmulatedProvider,
} from './parsers';
import { providerError, cacfError, organizationsError } from './errors';

export const getOrganizationsRequest = async (payload) => {
  const { data } = await http({
    id: 'cacf-get-organizations',
    resource: 'utility',
    method: 'GET',
    withCredentials: true,
    url: `${config('CACF_API_URL')}/v1/provider_privileges/search`,
    handleSuccess: organizationsError,
    handleError: organizationsError,
    query: {
      optumUuid: payload.uuid,
    },
  });

  return parseOrganizations(data);
};

export const getTaxIdNumbersRequest = async (payload) => {
  const { data } = await http({
    id: 'cacf-get-taxids',
    resource: 'utility',
    method: 'GET',
    url: `${config('CACF_API_URL')}/v1/provider_tax_ids/search`,
    handleSuccess: cacfError,
    query: {
      optumUuid: payload.uuid,
      uhcId: payload.organizationId,
      mpin: payload.corporateProviderMpin,
    },
  });

  return data.tinList || [];
};

export const getProvidersRequest = async (payload) => {
  const { data } = await http({
    id: 'cacf-get-providers',
    resource: 'utility',
    method: 'GET',
    url: `${config('CACF_API_URL')}/v1/providers/search`,
    handleSuccess: cacfError,
    query: {
      optumUuid: payload.uuid,
      uhcId: payload.organizationId,
      mpin: payload.corporateProviderMpin,
      tin: payload.taxIdNumber,
    },
  });

  return parseProviders(data);
};

export const getSavedProviderRequest = async (payload) => {
  const technicalUserData = getTechnicalUserData(payload);
  if (technicalUserData && technicalUserData.emulatedProvider) {
    return parseEmulatedProvider(technicalUserData);
  }

  const { data } = await http({
    id: 'get-saved-provider',
    resource: 'utility',
    method: 'GET',
    url: `${config('PROVIDER_SELECTION_API_URL')}`,
    handleError: providerError,
    headers: {
      uuid: payload.uuid,
    },
  });

  return parseProvider(data);
};

export const postSavedProviderRequest = async (payload) => {
  const splitName = payload.servicingProvider.name.split(', ');
  const servicingProviderFirstName = splitName[1];
  const servicingProviderLastName = splitName[0];
  const provider = {
    organization: {
      id: payload.organization.id,
      name: payload.organization.name,
    },
    corporateTaxOwner: {
      id: payload.corporateProvider.mpin,
      name: payload.corporateProvider.name,
    },
    taxIdNumber: {
      id: payload.taxIdNumber.tin,
    },
    careProvider: {
      id: payload.servicingProvider.mpin,
      firstName: servicingProviderFirstName,
      lastName: servicingProviderLastName,
    },
  };

  if (payload.save) {
    await http({
      id: 'submit-saved-provider',
      resource: 'utility',
      method: 'POST',
      url: `${config('PROVIDER_SELECTION_API_URL')}`,
      cache: false,
      headers: {
        uuid: payload.uuid,
      },
      body: provider,
    });
  }

  return {
    permissions: payload.organization.permissions,
    provider: parseProvider(provider),
  };
};
